import { useContext } from 'react';
import { styled } from '@core-ui/react-stitch';
import { BreakpointContext } from '@core-ui/breakpoint-provider';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import brDefaultStyleOverrides from './styles/br-default-style-overrides';
import brRedesignStyleOverrides from './styles/br-redesign-style-overrides';

type PriceWrapperProps = {
  isBRRedesignEnabled: boolean,
};

export const PriceWrapper = styled.div(({ isBRRedesignEnabled }: PriceWrapperProps) => {
  const { size } = useContext(BreakpointContext);
  const { abbrBrand } = useContext(BrandInfoContext);

  return {
    ...brDefaultStyleOverrides(),
    ...(isBRRedesignEnabled && brRedesignStyleOverrides({ size, abbrBrand }))
  };
});
